class BaseCalculator {
	quantity;
	measurement;
	productPrice;

	constructor(priceType, value) {
		this.priceType = priceType;
		this.value = value;
	}

	setParams(params) {
		this.quantity = params.quantity;
		this.measurement = params.measurement;
		this.productPrice = params.productPrice;
	}

	_getBasePrice() {
		return this.priceType === 'percent'
			? (this.productPrice * this.value) / 100
			: parseFloat(this.value);
	}

	getSummaryPrice() {
		return this.getPrice() * this.quantity;
	}

	getProductPrice() {
		return this.productPrice * this.quantity;
	}
}

export class PerItemCalculator extends BaseCalculator {
	getPrice() {
		return this._getBasePrice();
	}
}

export class FeeCalculator extends BaseCalculator {
	getPrice() {
		return this._getBasePrice();
	}

	getSummaryPrice() {
		return this.getPrice();
	}
}

export class PerMeasurementCalculator extends BaseCalculator {
	getPrice() {
		return this.priceType === 'percent'
			? (this.productPrice * this.value) / 100
			: parseFloat(this.value * this.measurement);
	}
}

export class FixedPriceCalculator extends BaseCalculator {
	getPrice() {
		const price =
			this.priceType === 'percent'
				? (this.productPrice * this.value) / 100
				: parseFloat(this.value);

		jQuery(document).trigger('fpf_price_calculator_change', {
			price,
		});

		return price;
	}
}
